<template>
  <l-map
    ref="map"
    style="position: relative; font-size:18px; height:600px; width: 100%; background-color:rgba(0, 0, 0, 0); color:#ffffff; z-index: 0;"
    :crs="crs"
    :min-zoom="minZoom4"
    :zoom="-1"
    :options="{scrollWheelZoom:false, zoomControl: false, doubleClickZoom: false, attributionControl:false,
               touchZoom: false, tap: false, dragging: false}"
  >
    <l-image-overlay
      :url="require('@/assets/images/icons/semcontrol/nbiot3/Diagram3p3.svg')"
      :bounds="bounds4"
    />
    <!-- Volt -->
    <l-marker
      v-if="markers.line_detect1 === 0 && markers.line_detect2 === 0"
      :lat-lng="[230, 700]"
    >
      <l-icon
        class-name="someExtraClass"
      >
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/abnormal2.gif')"
          height="68px"
        />
        <p class="headline nowrap">
          CB6: ผิดปกติ
        </p>
      </l-icon>
    </l-marker>
    <l-marker
      v-else
      :lat-lng="[200, 700]"
    >
      <l-icon
        class-name="someExtraClass"
      >
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/normald.png')"
          height="32px"
        />
        <p class="headline nowrap mt-2">
          CB6: ปกติ
        </p>
      </l-icon>
    </l-marker>
    <l-marker
      v-if="markers.line_detect3 === 0 && markers.line_detect4 === 0"
      :lat-lng="[230, 1000]"
    >
      <l-icon
        class-name="someExtraClass"
      >
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/abnormal2.gif')"
          height="68px"
        />
        <p class="headline nowrap">
          CB9: ผิดปกติ
        </p>
      </l-icon>
    </l-marker>
    <l-marker
      v-else
      :lat-lng="[200, 1000]"
    >
      <l-icon
        class-name="someExtraClass"
      >
        <b-img
          :src="require('@/assets/images/icons/semcontrol/diagram/normald.png')"
          height="32px"
        />
        <p class="headline nowrap mt-2">
          CB9: ปกติ
        </p>
      </l-icon>
    </l-marker>
    <!-- safety_swtich1 ----------------------------------------------------------->
    <l-marker
      v-if="markers.c_safety_swtich === '0'"
      :lat-lng="[456, -20]"
      :icon="iconLred"
    />
    <!-- safety_swtich2 -->
    <l-marker
      v-if="markers.c_safety_swtich_phase2 === '0'"
      :lat-lng="[456, 25]"
      :icon="iconLred"
    />
    <!-- safety_swtich3 -->
    <l-marker
      v-if="markers.c_safety_swtich_phase3 === '0'"
      :lat-lng="[456, 72]"
      :icon="iconLred"
    />
    <!-- main_breaker1 -------------------------------------------------------------->
    <l-marker
      v-if="markers.c_main_breaker === '0'|| markers.c_safety_swtich === '0'"
      :lat-lng="[273, -20]"
      :icon="iconLred"
    />
    <!-- main_breaker2 -->
    <l-marker
      v-if="markers.c_main_breaker_phase2 === '0'|| markers.c_safety_swtich_phase2 === '0'"
      :lat-lng="[273, 25]"
      :icon="iconLred"
    />
    <!-- main_breaker3 -->
    <l-marker
      v-if="markers.main_breaker_phase3 === '0'|| markers.c_safety_swtich_phase3 === '0'"
      :lat-lng="[273, 72]"
      :icon="iconLred"
    />
    <!-- mc k2 1-------------------------------------------------------------->
    <l-marker
      v-if="markers.c_magnetic_contactor1 === '0'|| markers.c_magnetic_contactor2 === '0' || markers.c_magnetic_contactor3 === '0'"
      :lat-lng="[83, -20]"
      :icon="iconLred"
    />
    <!-- mc k2 2 -->
    <l-marker
      v-if="markers.c_magnetic_contactor1_phase2 === '0'|| markers.c_magnetic_contactor2_phase2 === '0' || markers.c_magnetic_contactor3_phase2 === '0'"
      :lat-lng="[83, 25]"
      :icon="iconLred"
    />
    <!-- mc k2 3 -->
    <l-marker
      v-if="markers.c_magnetic_contactor1_phase3 === '0'|| markers.c_magnetic_contactor2_phase3 === '0' || markers.c_magnetic_contactor3_phase3 === '0'"
      :lat-lng="[83, 72]"
      :icon="iconLred"
    />
    <!-- Selector Switch -------------------------------------------------------------->
    <l-marker
      v-if="markers.c_safety_swtich === '0'|| markers.c_main_breaker === '0'"
      :lat-lng="[122, -268]"
      :icon="iconSelect"
    />
    <!-- Selector Photo -->
    <l-marker
      v-if="markers.c_photo_switch === '0'|| markers.c_safety_swtich === '0'|| markers.c_main_breaker === '0'"
      :lat-lng="[70, -464]"
      :icon="iconPhoto"
    />
    <!-- sub_breaker phase 1 -------------------------------------------------------------->
    <l-marker
      v-if="markers.c_sub_breaker2 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-212, -372]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_sub_breaker3 === '0'|| markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-212, -45]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_sub_breaker4 === '0'|| markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-212, 295]"
      :icon="iconLred"
    />
    <!-- sub_breaker phase2 ---------------------------->
    <l-marker
      v-if="markers.c_sub_breaker1_phase2 === '0'|| markers.c_main_breaker_phase2 === '0' || markers.c_safety_swtich_phase2 === '0'"
      :lat-lng="[-212, -302]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.sub_breaker2_phase2 === '0'|| markers.c_main_breaker_phase2 === '0' || markers.c_safety_swtich_phase2 === '0'"
      :lat-lng="[-212, 26]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.sub_breaker3_phase2 === '0'|| markers.c_main_breaker_phase2 === '0' || markers.c_safety_swtich_phase2 === '0'"
      :lat-lng="[-212, 364]"
      :icon="iconLred"
    />
    <!-- sub_breaker phase3 --------------------------->
    <l-marker
      v-if="markers.c_sub_breaker1_phase3 === '0'|| markers.c_main_breaker_phase3 === '0' || markers.c_safety_swtich_phase3 === '0'"
      :lat-lng="[-212, -232]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_sub_breaker2_phase3 === '0'|| markers.c_main_breaker_phase3 === '0' || markers.c_safety_swtich_phase3 === '0'"
      :lat-lng="[-212, 95]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_sub_breaker3_phase3 === '0'|| markers.c_main_breaker_phase3 === '0' || markers.c_safety_swtich_phase3 === '0'"
      :lat-lng="[-212, 434]"
      :icon="iconLred"
    />
    <!-- magnetic_contactor1 --------------------------->
    <l-marker
      v-if="markers.c_magnetic_contactor1 === '0' || markers.c_sub_breaker2 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, -372]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_magnetic_contactor1_phase2 === '0'|| markers.c_sub_breaker1_phase2 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, -302]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_magnetic_contactor1_phase3 === '0'|| markers.c_sub_breaker1_phase3 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, -232]"
      :icon="iconLred"
    />
    <!-- magnetic_contactor2 --------------------------->
    <l-marker
      v-if="markers.c_magnetic_contactor2 === '0' || markers.c_sub_breaker3 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, -45]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_magnetic_contactor2_phase2 === '0'|| markers.c_sub_breaker2_phase2 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, 25]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_magnetic_contactor2_phase3 === '0'|| markers.c_sub_breaker2_phase3 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, 95]"
      :icon="iconLred"
    />
    <!-- magnetic_contactor3 --------------------------->
    <l-marker
      v-if="markers.c_magnetic_contactor3 === '0' || markers.c_sub_breaker4 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, 296]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_magnetic_contactor2_phase3 === '0'|| markers.c_sub_breaker2_phase3 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, 364]"
      :icon="iconLred"
    />
    <l-marker
      v-if="markers.c_magnetic_contactor2_phase3 === '0'|| markers.c_sub_breaker2_phase3 === '0' || markers.c_main_breaker === '0' || markers.c_safety_swtich === '0'"
      :lat-lng="[-500, 434]"
      :icon="iconLred"
    />
  </l-map>
</template>

<script>
/* eslint-disable global-require */
import {
  BImg,
  // BButton, BCard,
} from 'bootstrap-vue'
import {
  LMap, LImageOverlay,
  LMarker,
  LIcon,
} from 'vue2-leaflet'
import { CRS, icon, Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'
import axios from '@axios'
// eslint-disable-next-line no-underscore-dangle
delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})
/* eslint-disable global-require */

export default {
  components: {
    LMap,
    LImageOverlay,
    LMarker,
    LIcon,
    BImg,
  },
  data() {
    return {
      waydetail: '',
      checkLeft1: '',
      checkRight1: '',
      checkLeft2: '',
      checkRight2: '',
      bounds4: [[-1400, 950], [950, -700]],
      iconSize: 64,
      crs: CRS.Simple,
      minZoom4: -1,
      deptid: '',
      markers: [],
      items: [],
      iconLred: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/Lred.svg'),
        iconSize: [72, 72],
        iconAnchor: [16, 37],
      }),
      iconSelect: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/handswitchred.svg'),
        iconSize: [74, 74],
        iconAnchor: [16, 37],
      }),
      iconPhoto: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/switchred.svg'),
        iconSize: [74, 74],
        iconAnchor: [16, 37],
      }),
      iconLight: icon({
        iconUrl: require('@/assets/images/icons/semcontrol/diagram/Lightingoff.svg'),
        iconSize: [60, 60],
        iconAnchor: [16, 37],
      }),
      sem_type: '',
      diagram_type: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.getCenterSem()
    this.getValueDiagram()
    this.interval = setInterval(() => {
      this.getValueDiagram()
      this.getCenterSem()
    }, 10000)
  },
  mounted() {
    this.$refs.map.mapObject.invalidateSize()
  },
  methods: {
    getCenterSem() {
      axios
        .post('/waySEMControlDetail', { wid: this.$route.query.wid })
        .then(response => {
          this.center = []
          this.waydetail = response.data[0].detail
          this.deptid = response.data[0].deptid
          this.type_name = response.data[0].type_name
          this.switch.semid = response.data[0].id
        })
        .catch(error => {
          console.log(error)
        })
    },
    getValueDiagram() {
      axios
        .post('/getDiagram3P', { wid: this.$route.query.wid })
        .then(response => {
          this.sem_type = response.data[0].firmware
          this.diagram_type = response.data[0].diagram_type
          // eslint-disable-next-line prefer-destructuring
          this.markers = response.data[0]
          console.log(response.data[0])
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
<style  lang="scss" scoped>
.headline {
  font-size: 16px;
}
.title {
  color:#FFFFD5
}
.nowrap {
  white-space: nowrap ;
}
</style>
